import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { List, Typography } from '@mui/material';
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import { useSelector } from "react-redux";

const NavGroup = ({ item }) => {
  const theme = useTheme();
  const { sidenav } = useSelector(state => state.users.payload?.data) ?? {}
  // menu list collapse & items
  const items = Array.isArray(sidenav) && sidenav.map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return <Typography key={menu.id} variant="h6" color="error" align="center"> Menu Items Error</Typography>;
    }
  });

  return (<>
    <List
      subheader={
        item.title && (
          <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
            {item.title}
            {item.caption && (
              <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                {item.caption}
              </Typography>
            )}
          </Typography>
        )
      }
    >
      {items}
    </List>
  </>);
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;